import React from "react";
import styles from "../styles/AchievementProgressBar.module.scss";
import {
  Badge,
  User,
  putCommasIntoNumber,
  BadgeCategory,
} from "@ecologi/shared";

interface Props {
  badge: Badge;
  user: User;
}

export const AchievementProgressBar: React.FC<Props> = ({ badge, user }) => {
  const { width, stat } = calculateWidth({ badge, user });

  return (
    <>
      <div className={styles.progressBar}>
        <div
          className={styles.progressBarInner}
          data-width={width}
          style={{ width }}
        />
      </div>
      <p className={styles.progressBarStat}>{stat}</p>
    </>
  );
};

interface Args {
  badge: Badge;
  user: User;
}

const calculateWidth = ({ badge, user }: Args) => {
  let width = 0;
  let stat = "";

  if (badge.category === BadgeCategory.TreesPlanted) {
    const numTrees = user.totalNumberOfTrees();
    width = Math.floor((numTrees / badge.total) * 100);
    stat = `${putCommasIntoNumber(numTrees)} / ${putCommasIntoNumber(
      badge.total
    )} trees`;
  }

  if (badge.category === BadgeCategory.SparklyTrees) {
    const numTrees = user.totalNumberOfSparkleTrees();
    width = Math.floor((numTrees / badge.total) * 100);
    stat = `${putCommasIntoNumber(numTrees)} / ${putCommasIntoNumber(
      badge.total
    )} sparkly trees`;
  }

  if (badge.category === BadgeCategory.ClimatePositive) {
    const numMonths = user.subscription?.timesRenewed || 0;
    width = Math.floor((numMonths / badge.total) * 100);
    stat = `${numMonths} / ${badge.total} months`;
  }

  if (badge.category === BadgeCategory.CarbonReduction) {
    const numTonnes = user.totalNumberOfTonnesOffset();
    width = Math.floor((numTonnes / badge.total) * 100);
    stat = `${numTonnes} / ${badge.total} tonnes`;
  }

  width = width > 100 ? 100 : width;

  return { width: width + "%", stat };
};
